import { defineMessages } from 'react-intl-next';

export const messages: {
	alignmentSectionTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	centerOption: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	collapseSectionLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	expandSectionLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	fixedOption: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	leftOption: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	rightOption: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	alignmentSectionTitle: {
		id: 'company-hub.links-menu-extension.alignment.title',
		defaultMessage: 'Alignment',
		description: 'Bolded text for the title of a section',
	},
	centerOption: {
		id: 'company-hub.links-menu-extension.center.option',
		defaultMessage: 'Center',
		description: 'Text on a button to select the center alignment option',
	},
	rightOption: {
		id: 'company-hub.links-menu-extension.right.option',
		defaultMessage: 'Right',
		description: 'Text on a button to select the right alignment option',
	},
	leftOption: {
		id: 'company-hub.links-menu-extension.left.option',
		defaultMessage: 'Left',
		description: 'Text on a button to select the left alignment option',
	},
	collapseSectionLabel: {
		id: 'company-hub.links-menu-extension.section.collapse.label',
		defaultMessage: 'Collapse section',
		description: 'Label on chevron down icon for collapsing a section',
	},
	expandSectionLabel: {
		id: 'company-hub.links-menu-extension.section.expand.label',
		defaultMessage: 'Expand section',
		description: 'Label on chevron right icon for expanding a section',
	},
	fixedOption: {
		id: 'company-hub.links-menu-extension.fixed.option',
		defaultMessage: 'Fixed at top',
		description: 'Label text for a toggle option to keep content at the top',
	},
});
